'use strict';

angular.module('TurneroApp').component('coPuestos', {
    bindings: {
        centroAtencionSeleccionado: '<'
    },
    controller: [
        '$state',
        'puestosService',
        'utilsService',
		'TurneroAppConstant',
        function ($state, puestosService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.puestoCrear = false;
            ctrl.puestoModificar = false;
            ctrl.puestoConsultar = true;
            ctrl.puestoVer = false;
            ctrl.puestos = {};
            ctrl.focusBuscar = false;
            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.order = false;

            ctrl.limitOptions = [10, 25, 50, 75, 100, {
                label: 'Todos',
                value: function () {
                    return ctrl.pagination.total;
                }
            }];

            ctrl.query = {
                limit: 10,
                page: 1,
                filter: ''
            };

            //Se inicializa en null para que al principio no tome que no hay valores
            ctrl.pagination = {
                total: null
            };

            ctrl.filter = false;

            ctrl.$onChanges = function () {
                ctrl.centroAtencionSeleccionado.id && ctrl.grillaReload();
            };

            ctrl.limpiarMemoria = function () {
                ctrl.puestos = {};
                ctrl.puestoCrear = false;
                ctrl.puestoModificar = false;
                ctrl.puestoConsultar = false;
                ctrl.puestoVer = false;
            }

            ctrl.removeFilter = function () {
                ctrl.query.filter = '';
                ctrl.grillaReload();
                ctrl.filter = false;
            };

            ctrl.mostrarBuscar = function () {
                ctrl.filter = true;
                ctrl.focusBuscar = true;
            };

            ctrl.grillaReload = function () {
                ctrl.limpiarMemoria();
                ctrl.puestoConsultar = true;

                if (ctrl.query.filter.length > 2 || ctrl.query.filter.length == 0) {
                    ctrl.getData(ctrl.query.page, ctrl.query.limit, 'grid', cargarDatos)
                }
            };
            
            ctrl.getData = function (page, limit, tipo, callback) {
                ctrl.promise = puestosService.getfiltro({
                    'filtro.id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id,
                    'filtro.nro_Pagina': page,
                    'filtro.tam_Pagina': limit,
                    'filtro.texto': ctrl.query.filter,
                }).$promise.then(function (data) {
                    callback(tipo, data);
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            function cargarDatos(tipo, data) {
                if (tipo == 'grid') {
                    ctrl.puestos = data.Data;
                    ctrl.pagination.total = data.Paging.Reg_Totales;
                } else if (tipo == 'xls') {
                    var arrayObjeto = data.Data;
                    ctrl.arrayExport = [];
                    ctrl.arrayExport[0] = ['Id', 'Nombre', 'Grupo', 'Centro de Atencion'];
                    for (var i = 0; i < arrayObjeto.length; i++) {
                        ctrl.arrayExport[i + 1] = [
                            arrayObjeto[i].Id_Puesto,
                            arrayObjeto[i].N_Puesto,
                            arrayObjeto[i].N_Grupo,
                            arrayObjeto[i].N_Centro_Atencion
                        ]
                    }
                    swal.close();
                    ctrl.Excel.down([{
                        name: 'Puestos',
                        data: ctrl.arrayExport
                    }]);
                }
            }

            ctrl.crearPuesto = function () {
                ctrl.limpiarMemoria();
                ctrl.puestoCrear = true;
                ctrl.tLoadAlta();
            };

            ctrl.modificarPuesto = function (item) {
                ctrl.limpiarMemoria();
                ctrl.puestoModificar = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.verPuesto = function (item) {
                ctrl.limpiarMemoria();
                ctrl.puestoVer = true;
                ctrl.tLoadModificar(item);
            };

            ctrl.eliminarPuesto = function (item) {
                swal({
                    title: "Eliminar Puesto",
                    text: "¿Desea quitar el puesto del centro de atención?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#e77a1e",
                    confirmButtonText: "Si, eliminarlo!",
                    cancelButtonText: "No, cancelar!",
                }).then(function () {
                    puestosService.delete({ 'id': item.Id_Puesto }).$promise.then(function (req) {
                        ctrl.grillaReload();
                        swal("Eliminado!", "El puesto ha sido eliminado del centro correctamente.", "success");
                    }).catch(function (req) {
                        utilsService.errores(req)
                    });

                });
            };

            ctrl.guardarOrden = function () {
                let ids = [];

                for (let i in ctrl.puestos) {
                    ids.push(ctrl.puestos[i].Id_Puesto);
                }

                puestosService.Guardar_Orden_Puestos({
                    'nro_Pagina': ctrl.query.page,
                    'tam_Pagina': ctrl.query.limit
                }, ids).$promise.then(function (res) {
                    sweetAlert("Ordenar", "Los Puestos se ordenaron correctamente", "success");
                    ctrl.grillaReload();
                    ctrl.order = false;
                }).catch(function (req) {
                    utilsService.errores(req);
                });
            };

            ctrl.cancelarOrden = function () {
                ctrl.grillaReload();
                ctrl.order = false;                
            };

            ctrl.onChangePagina = function () {
                if (ctrl.order) {
                    swal({
                        title: 'Atención',
                        html: '¿Desea guardar los cambios hasta el momento?',
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#004b81',
                        cancelButtonColor: '#971b2f',
                        confirmButtonText: "Sí",
                        cancelButtonText: "No",
                        allowEscapeKey: false,
                        allowOutsideClick: false
                    }).then(function (result) {
                        ctrl.guardarOrden();
                    }, function (error) {
                        ctrl.grillaReload();
                        swal.close();
                    });
                }
                else {
                    ctrl.grillaReload();
                }
            };

            //EXPORTAR A EXCEL
            ctrl.isOpen = false;
            ctrl.selectedMode = 'md-fling';
            ctrl.selectedDirection = 'up';
            ctrl.exportar = function (tipo) {

                utilsService.swalTitle('Exportando datos', 'info')
                ctrl.arrayExport = [];
                ctrl.getData(1, ctrl.pagination.total, tipo, cargarDatos)
            }
            ctrl.Excel = {
                down: function () {
                },
            }
        }
    ],
    template: require('./puestos.html')
});



// WEBPACK FOOTER //
// ./app/components/puestos/puestosComponent.js